var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-layout',[_c('MemberTeamModal'),_c('page-header',{attrs:{"heading":"Member Management","action":"Add","toggle":"offcanvas","target":"#offcanvasCreate","guard":this.$route.meta.guard},on:{"click":function($event){return _vm.setCreateForm('hello')}}}),_c('MemberTable',{attrs:{"tableHeading":_vm.tableHeading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }